import React from 'react'
import { Form } from 'react-bootstrap'

const FormController = React.forwardRef((props = {}, ref) => {
  const { onChange, onBlur, name, label, type, placeholder, errors } = props
  return (
    <Form.Group className="mb-3" controlId={name}>
      <Form.Label>
        {label}
        <span className="text-danger ml-0.5 text-base">*</span>
      </Form.Label>
      <Form.Control
        required
        as={type === 'textarea' ? 'textarea' : 'input'}
        type={type}
        placeholder={placeholder}
        className="shadow-none"
        name={name}
        ref={ref}
        onChange={onChange}
        onBlur={onBlur}
        isInvalid={errors[name]}
      />
      <Form.Control.Feedback type="invalid">
        {errors[name]?.message || ''}
      </Form.Control.Feedback>
    </Form.Group>
  )
})

export default FormController
